<template>
    <div>
        <h1>Compare Relative Position of All Indicators</h1>
        <keep-alive>
            <component :is="currentPage" />
        </keep-alive>
    </div>
</template>

<script type="module">
export default {
   name: 'Percentiles',
   components: {
     hospitals,
     percentilesvis
   }
}
</script>

<script setup>
import hospitals from './percentiles/hospitals.vue'
import percentilesvis from './percentiles/percentilesvis.vue'

import { storeToRefs } from 'pinia'
import { useVisualizationsStore } from '../stores/vis_store'

const {  loadPages, loadPage, nextPage, previousPage, setUser, setChartType, setYears, setDefaultYear, setDomains } = useVisualizationsStore()

const {   response, currentPage, pages, loading, arrindicators, user, charttype , defaultyear, domains} = storeToRefs(useVisualizationsStore())
const props = defineProps([  'currentPage', 'user', 'chartType', 'years', 'defaultYear', 'domains'])
//console.log(props);


loadPages({
     'hospitals': hospitals,
     'percentilesvis': percentilesvis,
    })



loadPage('hospitals');
setUser(props.user);
setChartType(props.chartType);
setYears(props.years);
setDefaultYear(props.defaultYear);
setDomains(props.domains);

</script>